import React from 'react'
import { styled } from '@mui/system'
import { colors, fontSizes } from '../consts'
import { LinkBtn } from '../Buttons/LinkBtn'

type HeaderProps = {
  buttonColor: 'blue' | 'green'
  uiTheme?: 'dark' | 'light'
}

export const InlineCon = styled('div')<HeaderProps>(
  ({ buttonColor, uiTheme, theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    margin: theme.spacing(2, 0),
    width: '100%',
    '& .innerCon': {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
      '& .hr': {
        display: 'flex',
        flexDirection: 'column',
        '& .infoCon': {
          display: 'flex',
          flexDirection: 'row',
          '& img': {
            height: 90,
            margin: theme.spacing(1, 1.5),
            [theme.breakpoints.down('sm')]: {
              height: 50,
              marginRight: 5,
            },
          },
          '& .textCon': {
            '& h1': {
              color: uiTheme === 'dark' ? colors.white : colors.text,
              fontWeight: 500,
              fontSize: fontSizes.semiLarge,
              [theme.breakpoints.down('sm')]: {
                fontSize: fontSizes.small,
                fontWeight: 700,
              },
            },
            '& .subtitle': {
              color: uiTheme === 'dark' ? colors.gray.gray20 : colors.text,
              fontWeight: 400,
              fontSize: fontSizes.medium,
              [theme.breakpoints.down('sm')]: {
                fontSize: fontSizes.small,
              },
            },
          },
        },
      },
    },
  })
)

export const ActionLink = styled('a')<HeaderProps>(({ buttonColor, theme }) => ({
  textDecoration: 'none',
  borderRadius: 16,
  height: 30,
  textAlign: 'center',
  color: colors.white,
  fontSize: fontSizes.medium,
  fontWeight: 'bold',
  background: buttonColor === 'green' ? colors.green : colors.lightBlue,
  padding: theme.spacing(1, 3),
  [theme.breakpoints.down('sm')]: {
    height: 20,
    padding: theme.spacing(0.5, 1.25),
    fontSize: fontSizes.small,
    marginRight: 3,
  },
}))

type HeaderParams = {
  title: string
  subtitle?: string
  imgUrl?: string
  buttonText?: string
  buttonLink?: string
  buttonColor?: 'blue' | 'green'
  uiTheme?: 'dark' | 'light'
  analytics?: { event: string; params?: any }
}

export const HrInline: React.FC<React.PropsWithChildren<HeaderParams>> = ({
  title,
  subtitle,
  imgUrl,
  buttonText,
  buttonLink,
  buttonColor = 'blue',
  uiTheme = 'light',
  analytics,
}) => {
  return (
    <InlineCon buttonColor={buttonColor} uiTheme={uiTheme}>
      <div className="innerCon">
        <div className="hr">
          <div className="infoCon">
            {imgUrl && <img src={imgUrl} alt={title} />}
            <div className="textCon">
              <h1>{title}</h1>
              {subtitle && <p className="subtitle">{subtitle}</p>}
            </div>
          </div>
        </div>
        {buttonText && buttonLink && (
          <LinkBtn
            btnStyle={'primary'}
            href={buttonLink}
            analytics={analytics}
            aria-label={buttonText}
          >
            {buttonText}
          </LinkBtn>
        )}
      </div>
    </InlineCon>
  )
}
